import React, { Fragment } from 'react';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/business/Footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import srImg from '../../images/services/quickscan/quickscan_info.webp';
import QuickScanForm from "../../components/QuickScanForm/QuickScanForm";
import Infographic from '../../images/services/quickscan/quickscan_infographic.svg';

const StartQuickScan = (props) => {


    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Ontdek uw online beveiliging met Praeventor QuickScan'} bgImage={Bg} />
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-last">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="about_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Beveilig jouw online aanwezigheid!
                                        </h2>
                                        <p className="heading_description mb-0">
                                            De Praeventor Quickscan biedt een snelle en betrouwbare analyse van de beveiligingsstatus van je bedrijf. Met een combinatie van geavanceerde tools en algoritmes scannen we je website en netwerk op kritieke beveiligingsrisico's, veelvoorkomende kwetsbaarheden, en basisinformatie over je netwerkbeveiliging. Binnen enkele minuten ontvang je een duidelijk overzicht van potentiële zwakke punten die mogelijk gevoelig zijn voor cyberaanvallen.
                                            <br></br>
                                        </p>
                                        <br></br>
                                        <p className="heading_description mb-0">
                                            Op basis van de scanresultaten krijg je gerichte aanbevelingen om je digitale beveiliging te verbeteren. Zo kun je snel en effectief inspelen op potentiële bedreigingen, nog voordat deze een risico vormen voor je bedrijf. Ontdek waar je beveiligingsprioriteiten liggen en ontvang een overzichtelijke rapportage met praktische stappen voor een veiligere digitale omgeving.
                                            <br></br>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="pt-130"></div>
                <div className="section_space pb-0" style={{ marginBottom: "200px"}}>
                    <div className="row justify-content-lg-center" >
                        <div className="col-lg-8">
                            <div>
                                <h3 className="details_item_info_title mb-1">Voer je QuickScan uit!</h3>
                                <p className="mb-5">
                                    Onze Quickscan geeft snel inzicht in de basisbeveiligingsrisico's, kwetsbaarheden en netwerkinformatie van je website en netwerk. Binnen enkele minuten na het starten van de scan ontvang je een overzichtelijk rapport met de belangrijkste bevindingen en aanbevelingen. Het resultaat wordt direct naar je e-mailadres gestuurd, zodat je meteen actie kunt ondernemen om je digitale beveiliging te versterken.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-8 ">
                            <div className="contact_form mb-0">
                                <QuickScanForm />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section_space pb-0 bg-light" >
                    <div className="row justify-content-lg-center" >
                        <div className="col-lg-8">
                            <div>
                                <h3 className="details_item_info_title mb-1">Zo werkt onze QuickScan</h3>
                                <p className="mb-5">
                                    Krijg binnen vijf eenvoudige stappen inzicht in je beveiligingsstatus. Onze Quickscan controleert je website en netwerk op basisrisico's en zwakke plekken, zodat je snel kunt handelen om je beveiliging te versterken.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-6 ">
                            <div className="contact_form mb-0" style={{paddingBottom: "200px"}}>
                                <img src={Infographic} alt="Quickscan roadmap"/>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <CtaSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default StartQuickScan;
